import debug from 'debug';

// Create namespaced debuggers
export const adminDebug = {
  posts: debug('admin:posts'),
  users: debug('admin:users'),
  locations: debug('admin:locations'),
  settings: debug('admin:settings'),
  api: debug('admin:api'),
  error: debug('admin:error')
};

// Enable all debuggers by default in development
if (process.env.NODE_ENV === 'development') {
  debug.enable('admin:*');
}

export default adminDebug; 